<template>
    <div class="container">
        <div class="social-store">
            <div class="social-store-inner">
                <h2 class="title-store">Мы всегда рядом</h2>
                <h4 class="text-store">Финсайт скоро доступен на мобильных устройствах</h4>
                <div class="markets-store">
                    <img src="@/assets/img/ruStore.svg" alt="RuStore">
                    <img src="@/assets/img/google_play.svg" alt="GooglePlay">
                    <img src="@/assets/img/appstore.svg" alt="AppStore">
                </div>
            </div>
            <picture>
                <source srcset="@/assets/img/phone-store-mob.webp" alt="phone" media="(max-width: 650px)" />
                <img class="phones-store" src="@/assets/img/phone-store.webp" alt="phone" />
            </picture>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SocialBanner',
    data() {
        return {};
    },
};
</script>

<style scoped lang="scss">
.social-store {
    background-image: url("~@/assets/img/store-bg.webp");
    background-size: cover;
    display: flex;
    justify-content: space-between;
    border-radius: 12px;
    margin-block: 60px 90px;
}

.social-store-inner {
    padding: 40px 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title-store {
        margin-bottom: 20px;
        font-family: "Gilroy";
        font-weight: 700;
        font-size: 64px;
        line-height: 100%;
        color: #22b491;
        text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        text-transform: uppercase;
    }

    .text-store {
        margin-bottom: 20px;
        font-family: "Gilroy";
        font-weight: 500;
        font-size: 40px;
        line-height: 100%;
        color: #f2f2f2;
    }

    .markets-store {
        display: block;
        justify-content: start;
        align-items: center;
    }

    .markets-store img {
        margin-right: 17px;
    }
}

.phones-store {
    height: 301px;
    margin-right: 109px;
}



@media screen and (max-width: 650px) {
    .social-store {
        position: relative;
        display: flex;
        width: 100vw;
        margin-left: calc((100vw - 289px)/-2);
        margin-block: 30px 40px;
        border-radius: 8px;

        .social-store-inner {
            width: 289px;
            margin: 0 auto;
            padding: 22px 0 17px;

            .title-store {
                margin-bottom: 14px;
                font-size: 23px;
            }

            .text-store {
                width: 205px;
                margin-bottom: 19px;
                font-size: 18px;
                padding: 0;
            }

            .markets-store img {
                width: 60px;
                height: 19px;
                margin-right: 7px;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            }
        }
    }

    .phones-store {
        display: block;
        position: absolute;
        bottom: 0px;
        right: 0px;
        height: 90%;
        margin: 0;
    }
}
</style>
